export function LogDecorator(color: string = 'red') {
  const colors: any = {
    red: '#dd4b39',
    blue: '#357ca5',
    green: '#008d4c'
  };

  return function(target: any, name: any, descriptor: any) {
    const fn: any = descriptor.value;
    descriptor.value = function() {
      console.log(`%c${target.name || target.constructor.name}`, `color: ${colors[color]}`, name, arguments);
      return fn.apply(this, arguments);
    };
  };
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/utils/log.decorator.ts